/**
 * Initiales pour la pastille header :
 * - 1 mot → 1 lettre (ChristianDemare → C)
 * - 2+ mots → 1ʳᵉ lettre des deux premiers (Christian Demare → CD, Stanislas de Nervo → SD)
 */
export function getUserInitials(name?: string, lastName?: string): string {
  const full = [name, lastName].filter(Boolean).join(" ").trim();
  if (!full) return "?";
  const parts = full.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0][0]!.toUpperCase();
  return (parts[0][0]! + parts[1][0]!).toUpperCase();
}

/** Palette pastille avatar (couleur tirée une fois puis persistée). */
export const USER_AVATAR_COLORS = [
  "#7C3AED", // violet
  "#2563EB", // bleu
  "#059669", // vert
  "#DC2626", // rouge
  "#D97706", // ambre
  "#DB2777", // rose
  "#0891B2", // cyan
  "#4F46E5", // indigo
  "#CA8A04", // jaune
  "#0D9488", // teal
] as const;

export const USER_AVATAR_COLOR_PREF_KEY = "user.avatarColor";

export function pickRandomAvatarColor(): string {
  const index = Math.floor(Math.random() * USER_AVATAR_COLORS.length);
  return USER_AVATAR_COLORS[index]!;
}
